export const calculateSyncTags = (newTags, currentTags) => {
  const tagsToAdd = newTags.filter(tag => !currentTags.includes(tag))
  const tagsToRemove = currentTags.filter(tag => !newTags.includes(tag))

  return {
    tagsToAdd,
    tagsToRemove,
  }
}
